import { ApplicationLendersSection } from "@porchpass/ui";
import type { InviteLender } from "./InvitePage";

export default ({
  lenders,
  onToggleEnabled,
  onToggleAutoSubmit,
  invalidSelection,
}: {
  lenders: InviteLender[];
  onToggleEnabled: (lenderId: string, enabled: boolean) => void;
  onToggleAutoSubmit: (lenderId: string, autoSubmit: boolean) => void;
  invalidSelection?: boolean;
}) => (
  <ApplicationLendersSection
    lenders={lenders.map((l) => ({
      lenderId: l.id,
      lenderName: l.name,
      logoUrl: l.logo_url,
      enabled: l.enabled,
      autoSubmit: l.autoSubmit,
      isPrimary: l.isPrimary,
    }))}
    onToggleEnabled={onToggleEnabled}
    onToggleAutoSubmit={onToggleAutoSubmit}
    error={invalidSelection ? "At least one lender must be enabled" : undefined}
  />
);
